require('./cardSecurePaymentStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatCardNumber } = require('utilities/cardsHelper');
// @ actions
const cardSecurePaymentActions = require('actions/cardSecurePayment');
// @ commons
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('components/commons/OKModal/OKModal');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @ constants
const { FIRST_STEP } = require('constants/index');
const { ECOMMERCE_KEY, ECOMMERCE_INTERNET_PAYMENTS_ADHERED } = require('constants/flagBasedFeatures');
// @ assets
const masterCardSecure = require('assets/images/mastercard-secure-logo.svg');
const verifiedVisa = require('assets/images/virified-visa-logo.svg');

class CardSecurePaymentStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false
        };

        this.handleModalToogle = this.handleModalToogle.bind(this);
        this.handleSecureCommerceChanged = this.handleSecureCommerceChanged.bind(this);
        this.handleNoSecureCommerceChanged = this.handleNoSecureCommerceChanged.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildSafetyMeasuresModal() {
        const content = (
            <React.Fragment>
                <p>
                    <FormattedText value="cardSecurePayment-firstStepSafetyMeasuresMessage1" />
                </p>
                <p>
                    <FormattedText value="cardSecurePayment-firstStepSafetyMeasuresMessage2" />
                </p>
            </React.Fragment>
        );

        return (
            <OKModal
                isOpen={this.state.modalIsOpen}
                onCloseCallback={this.handleModalToogle}
                content={content}
                title="cardSecurePayment-firstStepSafetyMeasuresTitle"
            />
        );
    }

    handleModalToogle() {
        this.setState({
            modalIsOpen: !this.state.modalIsOpen
        });
    }

    handleNoSecureCommerceChanged(evt) {
        this.props.handleNoSecureCommerceChanged(evt.target.checked);
    }

    handleSecureCommerceChanged(evt) {
        this.props.handleSecureCommerceChanged(evt.target.checked);
    }

    render() {
        const { immCardSecurePayment, immCard, immFlagBasedFeatures } = this.props;
        const isSecureCommerceChecked = !!immCardSecurePayment
            .get('steps')
            .get(FIRST_STEP)
            .get('isSecureCommerceChecked');
        const isNoSecureCommerceChecked = !!immCardSecurePayment
            .get('steps')
            .get(FIRST_STEP)
            .get('isNoSecureCommerceChecked');
        const firstStepCESLabel = formatText('cardSecurePayment-firstStepCESLabel');
        const firstStepNoCESLabel = formatText('cardSecurePayment-firstStepNoCESLabel');
        const safetyMeasuresModal = this.buildSafetyMeasuresModal();

        let renderBlock;

        if (!immCardSecurePayment.get('isFetching')) {
            if (immFlagBasedFeatures.get(ECOMMERCE_INTERNET_PAYMENTS_ADHERED) && immFlagBasedFeatures.get(ECOMMERCE_KEY)) {
                renderBlock = (
                    <div className="card-secure-payment-step-one">
                        {safetyMeasuresModal}
                        <header className="card-secure-payment-step-one__header">
                            <FormattedText
                                className="card-secure-payment-step-one__title"
                                value="cardSecurePayment-cardSecurePayment_firstStepTitlePayment"
                            />
                        </header>
                        <article className="card-secure-payment-step-one__content">
                            <FormattedText
                                value="cardSecurePayment-firstStepCardNumber"
                                injectedStrings={[formatCardNumber(immCard.get('number'), 4, '*')]}
                                className="card-secure-payment-step-one__subtitle"
                            />
                        </article>
                        <div className="card-secure-payment-step-one__section">
                            <FormattedText
                                className="card-secure-payment-step-one__heading-subtitle"
                                value="cardSecurePayment-firstStepTitle"
                            />
                            <p>
                                <FormattedText
                                    value="cardSecurePayment-cardSecurePayment_firstStepSecurePaymentInternet"
                                />
                            </p>
                            <WebappRender>
                                <p>
                                    <FormattedText
                                        avoidTargetBlank={true}
                                        value="cardSecurePayment-cardSecurePayment_firstStepSecurePaymentInternetLink"
                                    />
                                </p>
                            </WebappRender>
                        </div>
                        <ContactCenterRender>
                            <BlockInfo>
                                <p>
                                    <FormattedText value="cc_cardSecurePayment-cardSecurePayment_firstStepSecurePaymentCCPaymentActive" />
                                </p>
                            </BlockInfo>
                        </ContactCenterRender>
                        <div className="card-secure-payment-step-one__section">
                            <OKCheckbox
                                idName="securePaymentNoSecureCommerce"
                                value={isNoSecureCommerceChecked}
                                onChange={this.handleNoSecureCommerceChanged}
                                label={firstStepNoCESLabel}
                            />
                            <FormattedText
                                value="cardSecurePayment-cardSecurePayment_firstStepNoCESClauseActivePurchase"
                                className="card-secure-payment-step-one__section-content"
                            />
                        </div>
                        <div className="card-secure-payment-step-one__text">
                            <OKButton
                                modifier="link-complementary"
                                size="small"
                                onClick={this.handleModalToogle}
                            >
                                <FormattedText value="cardSecurePayment-firstStepSafetyMeasuresLabel" />
                            </OKButton>
                        </div>
                    </div>
                );
            } else {
                renderBlock = (
                    <div className="card-secure-payment-step-one">
                        {safetyMeasuresModal}
                        <header className="card-secure-payment-step-one__header">
                            <FormattedText
                                value="cardSecurePayment-firstStepTitle"
                                className="card-secure-payment-step-one__title"
                            />
                        </header>
                        <FormattedText value="cardSecurePayment-firstStepWarning" />
                        <article className="card-secure-payment-step-one__content">
                            <FormattedText
                                value="cardSecurePayment-firstStepCardNumber"
                                injectedStrings={[formatCardNumber(immCard.get('number'), 4, '*')]}
                                className="card-secure-payment-step-one__subtitle"
                            />
                            <div className="card-secure-payment-step-one__section">
                                <OKCheckbox
                                    idName="securePaymentSecureCommerce"
                                    value={isSecureCommerceChecked}
                                    onChange={this.handleSecureCommerceChanged}
                                    label={firstStepCESLabel}
                                />
                                <OKTooltip
                                    content="cardSecurePayment-firstStepTooltipContent"
                                    offset={[0, -10]}
                                    title="cardSecurePayment-firstStepTooltipHeader"
                                    type="explicative"
                                />
                                <FormattedText
                                    value="cardSecurePayment-firstStepCESClause"
                                    className="card-secure-payment-step-one__section-content"
                                />
                                <div className="card-secure-payment-step-one__section-ces-commerce">
                                    <img
                                        id="img_mastercard_secure"
                                        src={masterCardSecure}
                                        className="card-secure-payment-step-one__section-ces-commerce--icon"
                                    />
                                    <img
                                        id="img_verified_visa"
                                        src={verifiedVisa}
                                        className="card-secure-payment-step-one__section-ces-commerce--icon"
                                    />
                                    <span className="card-secure-payment-step-one__section-ces-commerce--separator">
                                        {' '}
                                    </span>
                                    <FormattedText
                                        value="cardSecurePayment-firstStepCESRecognitionMessage"
                                        className="card-secure-payment-step-one__section-ces-commerce--content"
                                    />
                                </div>
                            </div>
                            <div className="card-secure-payment-step-one__section">
                                <OKCheckbox
                                    idName="securePaymentNoSecureCommerce"
                                    value={isNoSecureCommerceChecked}
                                    onChange={this.handleNoSecureCommerceChanged}
                                    label={firstStepNoCESLabel}
                                />
                                <FormattedText
                                    value="cardSecurePayment-firstStepNoCESClause"
                                    className="card-secure-payment-step-one__section-content"
                                />
                            </div>
                            <div className="card-secure-payment-step-one__text">
                                <OKButton
                                    modifier="link-complementary"
                                    size="small"
                                    onClick={this.handleModalToogle}
                                >
                                    <FormattedText value="cardSecurePayment-firstStepSafetyMeasuresLabel" />
                                </OKButton>
                            </div>
                        </article>
                    </div>
                );
            }
        } else {
            renderBlock = <LoadingSection />;
        }

        return renderBlock;
    }
}

CardSecurePaymentStep1.propTypes = {
    immCard: PropTypes.object,
    immCardSecurePayment: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    handleSecureCommerceChanged: PropTypes.func.isRequired,
    handleNoSecureCommerceChanged: PropTypes.func.isRequired
};

module.exports.constructor = CardSecurePaymentStep1;
module.exports.CardSecurePaymentStep1 = connect(state => ({
    immFlagBasedFeatures: state.flagBasedFeatures,
}), {
    handleSecureCommerceChanged: cardSecurePaymentActions.secureCommerceChanged,
    handleNoSecureCommerceChanged: cardSecurePaymentActions.noSecureCommerceChanged
})(CardSecurePaymentStep1);